import React, { useState } from 'react';

import { Box } from 'ui/box';
import { Stack } from 'ui/stack';

import { Loader } from 'ui/loader';
import HeroContentType from 'containers/user/learn/components/hero-content-type/hero-content-type';
import NothingFound from 'containers/user/learn/components/empty-row/empty-row';
import CoursesCards from 'containers/user/learn/components/courses-cards/courses-cards';
import SeeMoreButton from 'containers/user/learn/components/see-more-btn/see-more-btn';
import useFetchAndUpdateCourses from 'containers/user/learn/containers/content/cources/use-fetch-courses';

import { useCurrentUser } from 'hooks/api/use-current-user';

const Courses = (): React.JSX.Element => {
  const [displayAll, setDisplayAll] = useState<boolean>(false);

  const user = useCurrentUser();

  const { loading, courses } = useFetchAndUpdateCourses(user?.data?.oktaUserId);

  const displayedCourses = displayAll ? courses : courses.slice(0, 4);

  return (
    <Box sx={{ width: '100%' }}>
      <Loader loading={loading} />
      <HeroContentType
        title="Courses"
        description="Explore the basics of MARKETview by watching our sequential user-training modules."
        breadcrumbs={[
          { label: 'Learn', href: '/learn' },
          { label: 'Courses', isActive: true },
        ]}
        customClass="pt-5"
      />
      <Stack sx={{ alignItems: 'center', mt: 5 }}>
        {!displayedCourses.length && !loading ? (
          <NothingFound contentType="courses" />
        ) : (
          <CoursesCards
            items={displayedCourses}
            userId={user?.data?.oktaUserId}
          />
        )}

        {courses.length > 4 && (
          <SeeMoreButton
            onClick={() => setDisplayAll(!displayAll)}
            showAll={displayAll}
          />
        )}
      </Stack>
    </Box>
  );
};

export default Courses;
